var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-autocomplete',{attrs:{"size":"is-medium","field":"name","max-height":"100px","placeholder":"Select Client","data":_vm.filteredResults,"open-on-focus":false,"readonly":_vm.readonly,"disabled":_vm.readonly},on:{"select":_vm.selectClient},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})
}
var staticRenderFns = []

export { render, staticRenderFns }